import { useSearchParams } from 'react-router';
import { Flex } from 'antd';
import { PageMeta } from '@app/components/meta/Meta';
import PageHeader from '@app/components/page/PageHeader';
import { PageTitle } from '@app/components/page/PageTitle';
import { PageLayout } from '@app/components/page';
import NodesEdgesProvider from './contexts/NodeEdgesProvider';
import DragAndDropFlow from './components/DragAndDropFlow';
import FlowWrapper from './components/FlowWrapper';
import FlowActionBtns from './components/buttons/FlowActionBtns';
import useFlow from '@app/hooks/flows/useFlow';
import NavToFlowListBtn from './components/buttons/NavToFlowListBtn';
import FlowBuilderTitle from './components/FlowBuilderTitle';
import FlowBuilderGuide from './components/drawers/FlowBuilderGuide';
import FlowContextBtn from './components/buttons/FlowContextBtn';
import { DEFAULT_FLOW_DATA } from './utils/constants';
import { StyledAlert } from '@app/components/alert/Alert';

const AIFlowBuilderAdd = () => {
    const [searchParams] = useSearchParams();
    const searchParamsId = searchParams.get('id');
    const { isLoading, data } = useFlow({ id: searchParamsId || '' });

    return (
        <>
            <PageMeta title="AI Agent Flows - Builder" />
            <StyledAlert title="BETA" />
            <NodesEdgesProvider initialData={data ?? DEFAULT_FLOW_DATA}>
                <PageHeader className="flow-builder-header">
                    <Flex justify="space-between" align="center" gap={20}>
                        <Flex gap={10} align="center">
                            <PageTitle title="Flow Builder" />
                            <FlowBuilderGuide />
                            <NavToFlowListBtn />
                            <FlowContextBtn />
                        </Flex>
                        {!isLoading && data?.name && <FlowBuilderTitle name={data.name} />}
                        <FlowActionBtns name={data?.name} type="Add" isLoading={isLoading} />
                    </Flex>
                </PageHeader>
                <PageLayout className="flow-builder-layout">
                    <FlowWrapper>
                        <DragAndDropFlow isLoading={isLoading} />
                    </FlowWrapper>
                </PageLayout>
            </NodesEdgesProvider>
        </>
    );
};
export default AIFlowBuilderAdd;
